export default "__VITE_ASSET__c2c12291__"